import { Avatar } from '@george-labs.com/design-system';
import type { ICON } from '@george-labs.com/george-assets/icons';

import type { AccountType } from '@shared/products-types';

import type { Account } from '../aggregation-service/types/aggregationService';
import { getDisplayedProductIcon } from './accountDisplayHelpers';

type Product = {
    origin?: Account['origin'];
    type: `${AccountType}`;
};

export const getAccountIcon = (product: Product): ICON =>
    product.origin && ['MBS', 'EBICS', 'SWIFT'].includes(product.origin)
        ? Avatar.ICON.BANK
        : getDisplayedProductIcon(product.type as AccountType);
